<!-- TrListPopPage -->
<template>
  <div class="tr-popup-overlay">
    <div class="tr-Popup-section">
    <!-- <div class="tr-Popup-section" :class="{ expanded: isExpanded }"> -->
      <div class="tr-popup-header">
        <div class="popup-title">{{this.shopNm}} / 점포정보</div>
        <button @click="closePopup" class="btn-close">닫기</button>
      </div>
      <div class="tr-popup-body">
      <div class="expandable-content">
        <ag-grid-vue
          class="ag-trPop-balham"
          :theme="theme"
          :style="{ width: '100%', height: gridHeight2 + 'rem' }"
          :rowData="rowData2"
          :columnDefs="columnDefs2"
          :gridOptions="gridOptions2"
          @grid-ready="onGridReady"
          :rowHeight="rowHeight"
          :enableCellSpan="true"
        ></ag-grid-vue>
      </div>
      <!-- 펼치기/접기 테이블 -->
      <div class="main-table-container">
        <!-- === 메인 달력 테이블 === -->
        <table class="main-table">
          <thead>
            <tr>
              <!-- <th>목표입력</th> -->
              <th>목표입력</th>
              <th>항목</th>
              <th>주간</th>
              <th>일</th>
              <th>월</th>
              <th>화</th>
              <th>수</th>
              <th>목</th>
              <th>금</th>
              <th>토</th>
            </tr>
          </thead>
          <!-- 로딩 중 -->
          <tbody v-if="mainTableLoading">
            <tr>
              <td :colspan="10">데이터 로딩 중...</td>
              <!-- Colspan 수정 -->
            </tr>
          </tbody>
          <!-- 데이터 있음 -->
          <tbody
            v-else-if="
              weeklySalesData.qtyWeeks && weeklySalesData.qtyWeeks.length > 0
            "
          >
            <template
              v-for="(qtyWeek, index) in weeklySalesData.qtyWeeks"
              :key="'week-group-' + index"
            >
              <!-- 수량 행 -->
              <tr>
                <td
                  v-if="index === 0"
                  style="color: red; background-color: #d0d0d0; font-size: 1rem"
                >
                  월목표
                </td>
                <td
                  v-if="index === 1"
                  :rowspan="2"
                  style="font-size: 1rem; font-weight: bold"
                >
                  {{ summaryInfo.monthlyGoalQty?.toLocaleString() || "-" }}
                </td>
                <td
                  v-if="index === 3"
                  style="color: red; background-color: #d0d0d0; font-size: 1rem"
                >
                  오늘목표
                </td>
                <td
                  v-if="index === 4"
                  :rowspan="3"
                  style="font-size: 1rem; font-weight: bold"
                >
                  {{ summaryInfo.dailyGoalQty?.toLocaleString() || "-" }}
                </td>
                <td
                  v-if="index === 0"
                  :rowspan="weeklySalesData.qtyWeeks.length + 1"
                >
                  수량
                </td>
                <td>{{ qtyWeek.week }}주</td>
                <td>{{ qtyWeek.sun }}</td>
                <td>{{ qtyWeek.mon }}</td>
                <td>{{ qtyWeek.tue }}</td>
                <td>{{ qtyWeek.wed }}</td>
                <td>{{ qtyWeek.thu }}</td>
                <td>{{ qtyWeek.fri }}</td>
                <td>{{ qtyWeek.sat }}</td>
              </tr>
            </template>
            <tr>
              <td colspan="2">누계</td>
              <td colspan="2">
                {{ summaryInfo.totalQty?.toLocaleString() || "-" }}
              </td>
              <td colspan="2">예상</td>
              <td colspan="2">
                {{ summaryInfo.projectedQtySum?.toLocaleString() || "-" }}
              </td>
            </tr>

            <!-- <template
              v-for="(qtyWeek, index) in weeklySalesData.qtyWeeks"
              :key="'week-group-' + index"
            >
              <tr class="score-row">
                <td
                  v-if="index === 0"
                  style="background-color: #d9d996; font-size: 1rem"
                >
                  월목표
                </td>
                <td
                  v-if="index === 1"
                  :rowspan="2"
                  style="font-size: 1rem; font-weight: bold"
                >
                  {{ summaryInfo.monthlyGoalPoints?.toLocaleString() || "-" }}
                </td>
                <td
                  v-if="index === 3"
                  style="background-color: #d9d996; font-size: 1rem"
                >
                  오늘목표
                </td>
                <td
                  v-if="index === 4"
                  :rowspan="3"
                  style="font-size: 1rem; font-weight: bold"
                >
                  {{ summaryInfo.dailyGoalPoints?.toLocaleString() || "-" }}
                </td>
                <td
                  v-if="index === 0"
                  :rowspan="weeklySalesData.qtyWeeks.length + 1"
                >
                  점수
                </td>
                <td>{{ weeklySalesData.pointWeeks[index].week }}주</td>
                <td>{{ weeklySalesData.pointWeeks[index].sun }}</td>
                <td>{{ weeklySalesData.pointWeeks[index].mon || "" }}</td>
                <td>{{ weeklySalesData.pointWeeks[index].tue || "" }}</td>
                <td>{{ weeklySalesData.pointWeeks[index].wed || "" }}</td>
                <td>{{ weeklySalesData.pointWeeks[index].thu || "" }}</td>
                <td>{{ weeklySalesData.pointWeeks[index].fri || "" }}</td>
                <td>{{ weeklySalesData.pointWeeks[index].sat || "" }}</td>
              </tr>
            </template>
            <tr class="score-row">
              <td colspan="2">누계</td>
              <td colspan="2">
                {{ summaryInfo.totalPoints?.toLocaleString() || "-" }}
              </td>
              <td colspan="2">예상</td>
              <td colspan="2">
                {{ summaryInfo.projectedPointSum?.toLocaleString() || "-" }}
              </td>
            </tr>
            <template
              v-for="(qtyWeek, index) in weeklySalesData.qtyWeeks"
              :key="'week-group-' + index"
            >
              <tr class="match-row">
                <td
                  v-if="index === 0"
                  style="background-color: #f2b1a5; font-size: 1rem"
                >
                  근무TO
                </td>
                <td
                  v-if="index === 1"
                  style="font-size: 1rem; font-weight: bold"
                >
                  {{ summaryInfo.personnelTO?.toLocaleString() || "-" }}
                </td>
                <td
                  v-if="index === 2"
                  style="background-color: #f2b1a5; font-size: 1rem"
                >
                  근무
                </td>
                <td
                  v-if="index === 3"
                  style="font-size: 1rem; font-weight: bold"
                >
                  {{ summaryInfo.personnelActual?.toLocaleString() || "-" }}
                </td>
                <td
                  v-if="index === 4"
                  style="background-color: #f2b1a5; font-size: 0.9rem"
                >
                  오늘적합도
                </td>
                <td
                  v-if="index === 5"
                  :rowspan="2"
                  style="font-size: 1rem; font-weight: bold"
                >
                  {{ summaryInfo.todayMatch?.toLocaleString() || "-" }}
                </td>
                <td
                  v-if="index === 0"
                  :rowspan="weeklySalesData.qtyWeeks.length + 1"
                >
                  인원적합도
                </td>
                <td>{{ weeklySalesData.matchWeeks[index].week }}주</td>
                <td>{{ weeklySalesData.matchWeeks[index].sun }}</td>
                <td>{{ weeklySalesData.matchWeeks[index].mon }}</td>
                <td>{{ weeklySalesData.matchWeeks[index].tue }}</td>
                <td>{{ weeklySalesData.matchWeeks[index].wed }}</td>
                <td>{{ weeklySalesData.matchWeeks[index].thu }}</td>
                <td>{{ weeklySalesData.matchWeeks[index].fri }}</td>
                <td>{{ weeklySalesData.matchWeeks[index].sat }}</td>
              </tr>
            </template>
            <tr class="match-row">
              <td colspan="2">평균</td>
              <td colspan="2">
                {{ summaryInfo.avgMatch?.toLocaleString() || "-" }}
              </td>
              <td colspan="2"></td>
              <td colspan="2"></td>
            </tr> -->
          </tbody>
          <!-- 데이터 없음 -->
          <tbody v-else>
            <tr>
              <td :colspan="10">데이터가 없습니다.</td>
              <!-- Colspan 수정 -->
            </tr>
          </tbody>
        </table>
      </div>
      </div>
      <!-- 버튼을 감싸는 컨테이너 추가 -->
      <!-- <div class="toggle-button-container">
        <button @click="toggleExpand" class="toggle-button">
          {{ isExpanded ? "▲ 펼치기" : "▼ 접기" }}
        </button>
      </div> -->
    </div>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue3";
import axios from "axios";
import "ag-grid-community/styles/ag-grid.css";
import { themeBalham } from "ag-grid-community";

export default {
  name: "PrListPopPage",
  components: {
    AgGridVue,
  },
  props: ["shopCd","shopNm"],
  data() {
    return {

      theme: themeBalham.withParams({
        fontFamily: "Malgun Gothic",
        borderColor: "#c0c0c0",
        wrapperBorder: true,
        headerRowBorder: true,
        headerColumnBorderHeight: "100%",
        rowBorder: { style: "solid", width: 1 },
        columnBorder: { style: "solid", width: 1 },
      }),

      rowData2: [], // AG Grid에 표시할 데이터

      mainTableData: [], // 메인 테이블 데이터

      totalCustomers: 0, // 총고객수

      availableCustomers: 0, // 가용 고객수

      // isExpanded: true, // 펼치기/접기 상태

      mainTableLoading: false, // 메인 테이블 로딩 상태

      rowHeight: window.innerWidth > 1024 ? 20 : 15.5, // 행 높이

      gridHeight2: window.innerWidth > 1024 ? 33 : 26, // 그리드2 높이

      columnDefs2: [
        {
          headerName: "",
          field: "year",
          pinned: "left",
          spanRows: true,
          cellClass: "year-cell",
          width: 22,
          maxWidth: 22,
          flex: 0.5,
          suppressSizeToFit: true,
          cellStyle: this.getRowStyleForGrid2,
        }, // 년도 열
        {
          headerName: "",
          field: "gubun",
          pinned: "left",
          width: 69,
          cellStyle: this.getRowStyleForGrid2,
        },
        // 월별 컬럼 정의 (반복문 사용)
        ...[...Array(12).keys()].map((i) => ({
          headerName: `${i + 1}월`,
          field: `${i + 1}month`,
          flex: 1,
          valueFormatter: this.commonValueFormatter, // 공통 포맷터 사용
          cellStyle: this.commonCellStyle, // 공통 셀 스타일 사용
        })),
        {
          headerName: "합계",
          field: "totalCnt",
          flex: 1,
          valueFormatter: this.commonValueFormatter, // 공통 포맷터 사용
          cellStyle: this.commonCellStyle,
        },
      ],

      defaultColDef: {
        resizable: true, // 열 크기 조정 가능
        sortable: true, // 정렬 가능
        // filter: true, // 필터 가능
        // minwidth: 50,
        headerHeight: 20,
        wrapHeaderText: true,
      },

      gridOptions2: {
        // enableSorting: true,
        // animateRows: true,
        quickFilterText: "",
        suppressNoRowsOverlay: true, // 데이터가 없을 때 오버레이 숨김
        tooltipShowMode: "whenTruncated",
        tooltipShowDelay: 0,
        defaultColDef: {
          resizable: false, // 열 크기 조정 가능
          sortable: false, // 정렬 가능
          tooltipValueGetter: (params) => params.value,
        },
        getRowStyle: (params) => {
          if (!params.data || !params.data.year) {
            return null; // 데이터가 없으면 기본 스타일 반환
          }

          const currentYear = new Date().getFullYear();
          const currentYY = parseInt(currentYear.toString().substring(2, 4));

          let yearStr = params.data.year.toString().replace("년", "");
          if (yearStr.length === 4) {
            yearStr = yearStr.substring(2, 4);
          }
          const yearYY = parseInt(yearStr);
          const diff = currentYY - yearYY;

          if (diff === 5) {
            return { background: "#ead6bf" };
          } else if (diff === 4) {
            return { background: "#bef29e" };
          } else if (diff === 3) {
            return { background: "#fff0fd" };
          } else if (diff === 2) {
            return { background: "#dcf3fc" };
          } else if (diff === 1) {
            return { background: "#f1fcb8" };
          } else if (diff === 0) {
            return { background: "#c8fdd1" };
          }
        },
        suppressDragLeaveHidesColumns: true, // 드래그 후 열 숨기기 방지
        headerHeight: 20,
      },

      summaryInfo: {
        // 헤더 및 요약 정보 저장 객체
        monthlyGoalQty: null, // 월 목표 수량 (arrDailySaleData(7, 0))
        dailyGoalQty: null, // 오늘 목표 수량 (arrDailySaleData(6, 0))
        monthlyGoalPoints: null, // 월 목표 점수 (arrDailySaleData(5, 0))
        dailyGoalPoints: null, // 오늘 목표 점수 (계산됨)
        personnelTO: null, // 근무 TO (오늘 데이터)
        personnelActual: null, // 근무 (오늘 데이터)
        todayMatch: null, // 오늘 적합도 (오늘 데이터)
        totalQty: 0, // 총 판매수량 (계산됨)
        totalPoints: 0, // 총 판매점수 (계산됨)
        totalMatch: 0, // 총 적합도 (계산됨)
        projectedQtySum: null, // 예상 월 수량 합계 (계산됨)
        projectedPointSum: null, // 예상 월 점수 합계 (계산됨)
        avgMatch: null, // 평균 적합도 (계산됨)
        currentDayOfMonth: new Date().getDate(), // 오늘 날짜 (일)
        lastDayOfMonth: new Date(
          new Date().getFullYear(),
          new Date().getMonth() + 1,
          0
        ).getDate(), // 이 달의 마지막 날짜 (일)
      },
    };
  },
  mounted() {
    if (this.shopCd) {
      this.details(this.shopCd);
      // this.storeTotMem(this.shopCd);
      this.monthSaleQtyData(this.shopCd);
    }

    window.addEventListener("resize", this.handleResize);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {

    onGridReady(params) {
      this.gridApi = params.api;
    },

    handleResize() {
      const isWide = window.innerWidth > 1024;
      const newRowHeight = isWide ? 20 : 15.5;
      const newGridHeight2 = isWide ? 33 : 26;
      if (this.rowHeight !== newRowHeight) {
        this.rowHeight = newRowHeight;
        if (this.gridApi) this.gridApi.resetRowHeights();
      }
      if (this.gridHeight2 !== newGridHeight2) {
        this.gridHeight2 = newGridHeight2;
      }
    },

    closePopup() {
      this.$emit("close");
    },

    async details(shopCd) {
      try {
        const response = await axios.get(
          `/api/seListPage/details?shopCd=${shopCd}`
        );
        const data = response.data;

        // 응답 데이터가 배열인지 확인
        this.rowData2 = this.transformData(data);
      } catch (error) {
        console.error("데이터 조회 오류:", error);
      }
    },

    async storeTotMem(shopCd) {
      try {
        const currentDate = new Date();
        const currentYearMonth = `${currentDate.getFullYear()}-${String(
          currentDate.getMonth() + 1
        ).padStart(2, "0")}`; // 현재 연도와 월을 "YYYY-MM" 형식으로 조합

        const response = await axios.get(
          `/api/seListPage/storeTotMem?year=${currentYearMonth}&shopCd=${shopCd}`
        );
        const data = response.data;

        this.totalCustomers = Number(data.CST_TOT_CNT) || 0; // 총고객수
        this.availableCustomers = Number(data.DIFFERENCE) || 0; // 가용 고객수
      } catch (error) {
        console.error("추가 데이터 가져오기 오류:", error);
      }
    },

    transformData(data) {
      const transformed = {};
      const currentYear = new Date().getFullYear(); // 현재 연도

      // 최고 판매수량 계산
      const maxSaleQtyByMonth = {};

      if (!Array.isArray(data)) {
        console.error("transformData: 입력 데이터가 배열이 아닙니다.", data);
        return [];
      }

      data.forEach((row) => {
        if (!row || !row.SALE_MM) {
          // 문제가 있는 데이터 건너뛰기
          return; // 현재 반복 건너뛰고 다음 row 처리
        }

        const year = parseInt(row.SALE_MM.substring(0, 4)); // 년도 추출
        const month = parseInt(row.SALE_MM.substring(4, 6)); // 월 추출
        const yearYY = year.toString().substring(2, 4); // 연도 YY 추출

        // 월별 최고 판매수량 계산
        if (year <= currentYear - 1) {
          if (
            !maxSaleQtyByMonth[month] ||
            maxSaleQtyByMonth[month] < parseInt(row.SALE_QTY)
          ) {
            maxSaleQtyByMonth[month] = parseInt(row.SALE_QTY);
          }
        }
        if (!transformed[year]) {
          if (year === currentYear) {
            transformed[year] = {
              // 회장님 지시사항 반영 으로  경영지도,부점장명 제거
              // manageGuid: { year: `${year}년`, gubun: "경영지도" },
              ownerName: { year: `${year}년`, gubun: "사업주명" },
              // branchManager: { year: `${year}년`, gubun: "부점장명" },
              // 회장님 지시사항 반영 20260129 "예정약금", "실제약금", "차이"  추가
              suretyEd: { year: `${year}년`, gubun: "계약일" },
              plannedAmount: { year: `${year}년`, gubun: "예정약금" },
              appliedRate: { year: `${year}년`, gubun: "적용률" },
              actualAmount: { year: `${year}년`, gubun: "실제약금" },
              amountDiff: { year: `${year}년`, gubun: "차액" },
              maxQty: { year: `${year}년`, gubun: "최고수량" },
              salesQty: { year: `${year}년`, gubun: "판매수량" },
              qtyDiff: { year: `${year}년`, gubun: "수량차이" },
              // 회장님 지시사항 반영 20260209 평균점수제거
              averaScore: { year: `${year}년`, gubun: "평균점수" },
              // 회장님 지시사항 반영 20260204 "매출액", "수수료", "수수료율", "보증금액", "재고수량", "이월수량", "이월비율"  추가
              salesRevenue: { year: `${year}년`, gubun: "매출액" },
              commission: { year: `${year}년`, gubun: "수수료" },
              commissionRate: { year: `${year}년`, gubun: "수수료율" },
              depositAmount: { year: `${year}년`, gubun: "보증금액" },
              inventoryQuantity: { year: `${year}년`, gubun: "재고수량" },
              carryoverQuantity: { year: `${year}년`, gubun: "이월수량" },
              carryoverRate: { year: `${year}년`, gubun: "이월비율" },
              auditDate: { year: `${year}년`, gubun: "감사일자" },
            };
          } else if (year === currentYear - 1) {
            transformed[year] = {
              ownerName: { year: `${yearYY}년`, gubun: "사업주명" },
              salesQty: { year: `${yearYY}년`, gubun: "판매수량" },
              qtyDiff: { year: `${yearYY}년`, gubun: "수량차이" },
              // averaScore: { year: `${yearYY}년`, gubun: "평균점수" },
              auditDate: { year: `${yearYY}년`, gubun: "감사일자" },
            };
          } else {
            transformed[year] = {
              ownerName: { year: `${yearYY}년`, gubun: "사업주명" },
              salesQty: { year: `${yearYY}년`, gubun: "판매수량" },
              qtyDiff: { year: `${yearYY}년`, gubun: "수량차이" },
            };
          }
        }

        // 하위 객체 초기화 확인
        if (!transformed[year].salesQty) {
          transformed[year].salesQty = {};
        }
        if (!transformed[year].qtyDiff) {
          transformed[year].qtyDiff = {};
        }

        // 사업주명 추가
        transformed[year].ownerName[`${month}month`] = row.SHOP_MASTER_NM || "";

        // 판매수량 추가
        // transformed[year].salesQty[`${month}month`] = Math.round(row.SALE_QTY);
        if (row.SALE_QTY != null ) {
          transformed[year].salesQty[`${month}month`] = Math.round(
            row.SALE_QTY,
          );
        }

        if (year <= currentYear - 2) {
          // 현재 연도 - 5년의 값은 "GAP"으로 설정
          transformed[year].qtyDiff[`${month}month`] = row.GAP;
        }

        if (year >= currentYear - 1) {
          transformed[year].auditDate[`${month}month`] = row.AUDIT_DATE ?? "";
          // transformed[year].averaScore[`${month}month`] = Math.round(
          //   row.SALE_SCORE_AVG,
          // );
        // if (row.SALE_SCORE_AVG != null && !isNaN(Number(row.SALE_SCORE_AVG))) {
        //     transformed[year].averaScore[`${month}month`] = Math.round(
        //       row.SALE_SCORE_AVG,
        //     );
        //   }
        }

        if (year === currentYear) {
          // 회장님 지시사항 반영 20260204 경영지도, 부점장 제거 
          // transformed[year].manageGuid[`${month}month`] = row.SHOP_CEO_NM || "";
          // transformed[year].branchManager[`${month}month`] = row.SHOP_MANAGER_NM || "";
          // transformed[year].averaScore[`${month}month`] = Math.round(
          //   row.SALE_SCORE_AVG,
          // );
          if (row.SALE_SCORE_AVG != null && !isNaN(Number(row.SALE_SCORE_AVG))) {
            transformed[year].averaScore[`${month}month`] = Math.round(
              row.SALE_SCORE_AVG,
            );
          }

          transformed[year].suretyEd[`${month}month`] = row.SURETY_ED;
          transformed[year].plannedAmount[`${month}month`] = row.PLAN_AMOUNT;
          transformed[year].appliedRate[`${month}month`] = row.APPLIED_RATE != null ? row.APPLIED_RATE + "%" : "";
          transformed[year].actualAmount[`${month}month`] = row.ACTUAL_AMOUNT;
          transformed[year].amountDiff[`${month}month`] = row.AMOUNT_DIFF;

          transformed[year].salesRevenue[`${month}month`] = row.DCM_SALE_AMT;
          transformed[year].commission[`${month}month`] = row.COMMISSION_AMT;
          transformed[year].commissionRate[`${month}month`] = 
            row.COMMISSION_AMT != null ? (row.COMMISSION_AMT/row.DCM_SALE_AMT * 100).toFixed(1) + "%" : "";
          transformed[year].depositAmount[`${month}month`] = row.LASTPROFIT;
          transformed[year].inventoryQuantity[`${month}month`] = row.CLOSE_QTY;
          transformed[year].carryoverQuantity[`${month}month`] = row.CLOSE_CVR_QTY;
          transformed[year].carryoverRate[`${month}month`] = row.CARRYOVER_RATE != null ? row.CARRYOVER_RATE + "%" : "";
        }
      });

      // 특정 연도와 월 키에 대한 판매 수량
      const getQty = (transformed, year, monthKey) => {
        // 옵셔널 체이닝을 사용하여 중첩된 속성에 안전하게 접근
        return parseInt(transformed[year]?.salesQty?.[monthKey] || 0);
      };

      // --- 수량 차이(qtyDiff) 및 최고 수량(maxQty) 계산 ---
      Object.keys(transformed).forEach((yearStr) => {
        const numYear = parseInt(yearStr); // 문자열 연도를 숫자로 변환
        const salesQtyRow = transformed[yearStr]?.salesQty; // salesQty 행을 가져옴

        // --- 수량 차이(qtyDiff) 계산 ---
        if (
          salesQtyRow &&
          numYear >= currentYear - 5 &&
          numYear <= currentYear
        ) {
          // qtyDiff가 계산되는 연도에 대해 qtyDiff 객체가 존재하는지 확인하고 없으면 생성
          if (numYear >= currentYear - 3 && !transformed[yearStr].qtyDiff) {
            transformed[yearStr].qtyDiff = {
              year: yearStr.substring(2, 4),
              gubun: "수량차이",
            };
          }

          // salesQtyRow에 있는 월 키들을 순회
          Object.keys(salesQtyRow).forEach((key) => {
            // 실제 월 키('1month', '12month' 등)만 처리
            if (key.endsWith("month")) {
              const currentSaleQty = parseInt(salesQtyRow[key]) || 0; // 현재 월의 판매 수량
              const monthKey = key; // key는 이미 'Nmonth' 형식임

              let maxSaleQty = 0; // 해당 월의 이전 연도들 중 최고 판매 수량
              let diff = 0; // 수량 차이

              // 연도에 따라 특정 차이 계산 로직 적용 (원본 코드와 동일)
              if (numYear === currentYear - 3) {
                // -3년차: 이전 3개년 (currentYear-5, currentYear-4, currentYear-3) 중 최고값 계산
                maxSaleQty = Math.max(
                  getQty(transformed, currentYear - 5, monthKey),
                  getQty(transformed, currentYear - 4, monthKey),
                  getQty(transformed, currentYear - 3, monthKey),
                );
                diff = currentSaleQty - maxSaleQty;
                // 차이가 0일 경우, 자신을 제외한 이전 연도들 중 최고값과 비교
                if (diff === 0) {
                  const nextMaxSaleQty = Math.max(
                    getQty(transformed, currentYear - 5, monthKey),
                    getQty(transformed, currentYear - 4, monthKey),
                  );
                  diff = currentSaleQty - nextMaxSaleQty;
                }
                transformed[yearStr].qtyDiff[monthKey] = diff;
              } else if (numYear === currentYear - 2) {
                // -2년차: 이전 4개년 중 최고값 계산
                maxSaleQty = Math.max(
                  getQty(transformed, currentYear - 5, monthKey),
                  getQty(transformed, currentYear - 4, monthKey),
                  getQty(transformed, currentYear - 3, monthKey),
                  getQty(transformed, currentYear - 2, monthKey),
                );
                diff = currentSaleQty - maxSaleQty;
                // 차이가 0일 경우, 자신을 제외한 이전 연도들 중 최고값과 비교
                if (diff === 0) {
                  const nextMaxSaleQty = Math.max(
                    getQty(transformed, currentYear - 5, monthKey),
                    getQty(transformed, currentYear - 4, monthKey),
                    getQty(transformed, currentYear - 3, monthKey),
                  );
                  diff = currentSaleQty - nextMaxSaleQty;
                }
                transformed[yearStr].qtyDiff[monthKey] = diff;
              } else if (numYear === currentYear - 1) {
                // -1년차: 이전 5개년 중 최고값 계산
                maxSaleQty = Math.max(
                  getQty(transformed, currentYear - 5, monthKey),
                  getQty(transformed, currentYear - 4, monthKey),
                  getQty(transformed, currentYear - 3, monthKey),
                  getQty(transformed, currentYear - 2, monthKey),
                  getQty(transformed, currentYear - 1, monthKey),
                );
                diff = currentSaleQty - maxSaleQty;
                // 차이가 0일 경우, 자신을 제외한 이전 연도들 중 최고값과 비교
                if (diff === 0) {
                  const nextMaxSaleQty = Math.max(
                    getQty(transformed, currentYear - 5, monthKey),
                    getQty(transformed, currentYear - 4, monthKey),
                    getQty(transformed, currentYear - 3, monthKey),
                    getQty(transformed, currentYear - 2, monthKey),
                  );
                  diff = currentSaleQty - nextMaxSaleQty;
                }
                transformed[yearStr].qtyDiff[monthKey] = diff;
              } else if (numYear === currentYear) {
                // 현재 연도: 이전 5개년 중 최고값 계산
                maxSaleQty = Math.max(
                  getQty(transformed, currentYear - 5, monthKey),
                  getQty(transformed, currentYear - 4, monthKey),
                  getQty(transformed, currentYear - 3, monthKey),
                  getQty(transformed, currentYear - 2, monthKey),
                  getQty(transformed, currentYear - 1, monthKey),
                );
                // 현재 연도는 diff === 0 케이스 처리가 원본 로직에 없음
                diff = currentSaleQty - maxSaleQty;
                transformed[yearStr].qtyDiff[monthKey] = diff;
              }
              // 참고: currentYear - 4년 이하의 연도에 대해서는 여기서 qtyDiff가 계산되지 않음
              // DB에서 이전에 설정된 'GAP' 값을 유지
            }
          });
        }

        // --- *현재* 연도의 최고 수량(maxQty) 행 계산 ---
        if (numYear === currentYear) {
          // 현재 연도에 maxQty 객체가 존재하는지 확인하고 없으면 생성
          if (!transformed[yearStr].maxQty) {
            transformed[yearStr].maxQty = {
              year: yearStr.substring(2, 4),
              gubun: "최고수량",
            };
          }

          let totalMaxSaleQty = 0; // 월별 최고 수량의 총합을 저장할 변수
          for (let m = 1; m <= 12; m++) {
            const monthKey = `${m}month`;
            // 해당 월에 대해 이전 5개년 간의 최고 판매 수량 계산
            const monthlyMax = Math.max(
              getQty(transformed, currentYear - 5, monthKey),
              getQty(transformed, currentYear - 4, monthKey),
              getQty(transformed, currentYear - 3, monthKey),
              getQty(transformed, currentYear - 2, monthKey),
              getQty(transformed, currentYear - 1, monthKey),
            );
            // 계산된 월별 최고 수량을 현재 연도의 maxQty 행에 할당
            transformed[yearStr].maxQty[monthKey] = monthlyMax;
            totalMaxSaleQty += monthlyMax; // 총합 누적
          }
          // 계산된 총합을 'totalCnt' 필드에 할당
          transformed[yearStr].maxQty["totalCnt"] = totalMaxSaleQty;
        }
      });
      // --- 끝: 수량 차이 및 최고 수량 계산 ---

      // (salesQty, qtyDiff 등의 totalCnt 계산을 위한 후속 루프가 여기에 와야 함)
      Object.keys(transformed).forEach((yearStr) => {
        // 합계를 계산할 모든 관련 타입 포함
        [
          "salesQty",
          "qtyDiff",
          "maxQty",
          "averaScore",
          "plannedAmount",
          "appliedRate",
          "actualAmount",
          "amountDiff",
          "salesRevenue",
          "commission",
          "commissionRate",
        ].forEach((type) => {
          const row = transformed[yearStr]?.[type]; // 해당 타입의 행을 안전하게 가져옴
          if (row) {
            // 행이 존재하는 경우에만 계산
            let sum = 0; // 합계를 저장할 변수 초기화
            let count = 0;
            for (let m = 1; m <= 12; m++) {
              // 1월부터 12월까지 반복
              const monthKey = `${m}month`; // 월 키 생성 (예: '1month')
              // 값을 더하기 전에 숫자인지 확인하고, 아니면 0으로 처리
              // const value = parseInt(row[monthKey]) || 0;
              
              let value = row[monthKey];

              if (type === "commissionRate") {
                if (typeof value === "string" && value.includes("%")) {
                  value = parseFloat(value.replace("%", ""));
                } else {
                  value = parseFloat(value) || 0;
                }
                if (value !== 0) count++;
              } else {
                if (type === "averaScore" && value != null && value !== "") {
                  count++;
                }
                value = parseInt(value) || 0;
              }

              sum += value; // 합계 누적
            }
            // row["totalCnt"] = sum; // 계산된 합계를 'totalCnt' 필드에 할당
            if (type === "commissionRate") {
              row["totalCnt"] = count > 0 ? (sum / count).toFixed(1) + "%" : "";
            } else if (type === "appliedRate"){
              row["totalCnt"] = sum + "%";
            } else if (type === "averaScore"){
              row["totalCnt"] = count > 0 ? (sum / count).toFixed(1) : "";
            } else {
              row["totalCnt"] = sum; // 계산된 합계를 'totalCnt' 필드에 할당
            }
          }
        });
      });

      // 결과를 배열로 변환
      // 회장님 지시사항 반영 테스트 "-5년 제거"
      // return Object.values(transformed).flatMap((yearData) =>
      //   Object.values(yearData)
      // );
      return Object.keys(transformed)
        .filter((year) => parseInt(year) > currentYear - 3)
        .map((year) => transformed[year])
        .flatMap((yearData) => Object.values(yearData));
    },
  
    async monthSaleQtyData(shopCd) {
      this.mainTableLoading = true; // 로딩 시작
      this.mainTableData = null; // 이전 데이터 초기화
      this.resetSummaryInfo(); // 요약 정보 초기화

      const today = new Date();
      const year = today.getFullYear();
      const month = today.getMonth() + 1;
      const day = today.getDate();

      // 현재 월의 첫 날 (YYYY-MM-DD 형식)
      const startDate = `${year}${String(month).padStart(2, "0")}01`;
      const thisDate = `${year}${String(month).padStart(2, "0")}${String(
        day
      ).padStart(2, "0")}`; // 현재 날짜 (YYYY-MM-DD 형식)

      try {
        const response = await axios.get("/api/seListPage/monthSaleQtyData", {
          params: {
            shopCd: shopCd,
            startDate: startDate,
            thisDate: thisDate, // 백엔드에서 thisDate를 사용하므로 전달
          },
        });

        if (
          response.data &&
          Array.isArray(response.data) &&
          response.data.length > 0
        ) {
          this.mainTableData = response.data; // 데이터 저장
          this.processSummaryData(this.mainTableData); // 요약 정보 처리
          // this.isExpanded = true;
        } else {
          this.mainTableData = [];
          // this.isExpanded = false;
        }
      } catch (error) {
        console.error(
          "Main Table 데이터 가져오기 오류:",
          error.response ? error.response.data : error.message
        );
        this.mainTableData = [];
        // this.isExpanded = false;
      } finally {
        this.mainTableLoading = false;
      }
    },

    // 요약 정보 처리 메소드
    processSummaryData(data) {
      if (!data || data.length === 0) return;

      const firstRecord = data[0];
      const todayString = new Date().toLocaleDateString("sv").replace(/-/g, ""); // 'YYYYMMDD' 형식
      const todayData = data.find((d) => d.YYYYMMDD === todayString);

      // 1. 헤더 값 설정 (첫 번째 레코드 기준)
      this.summaryInfo.monthlyGoalQty = firstRecord.ZB_GOAL_MM;
      this.summaryInfo.dailyGoalQty = firstRecord.ZB_GOAL_DD;
      this.summaryInfo.monthlyGoalPoints = parseFloat(
        firstRecord.ZA_MNGOAL || 0
      );

      // 오늘 목표 점수 계산 (VBA 로직 유사하게)
      const monthlyGoalPointsNum = this.summaryInfo.monthlyGoalPoints;
      if (monthlyGoalPointsNum > 0 && this.summaryInfo.lastDayOfMonth > 0) {
        // VBA의 CInt는 반올림과 유사하게 동작할 수 있으므로 Math.round 사용
        this.summaryInfo.dailyGoalPoints = Math.round(
          monthlyGoalPointsNum / this.summaryInfo.lastDayOfMonth
        );
      } else {
        this.summaryInfo.dailyGoalPoints = 0;
      }

      // 2. 오늘 날짜 기준 값 설정
      if (todayData) {
        this.summaryInfo.personnelTO = todayData.ZB_PERSONNEL || 0;
        this.summaryInfo.personnelActual = todayData.ZB_WORK_CNT || 0;
        this.summaryInfo.todayMatch = todayData.MATCH || 0;
      }

      // 3. 전체 합계 계산
      this.summaryInfo.totalQty = data.reduce(
        (sum, d) => sum + parseInt(d.SALE_QTY || 0),
        0
      );
      this.summaryInfo.totalPoints = Math.round(
        data.reduce((sum, d) => sum + parseFloat(d.SUM_POINT_DAY || 0), 0)
      );
      this.summaryInfo.totalMatch = data.reduce(
        (sum, d) => sum + parseInt(d.MATCH || 0),
        0
      );

      // 4. 예상/평균 계산
      const dayOfMonth = this.summaryInfo.currentDayOfMonth;
      const lastDayOfMonth = this.summaryInfo.lastDayOfMonth;

      if (dayOfMonth > 0) {
        this.summaryInfo.projectedQtySum = Math.round(
          (this.summaryInfo.totalQty / dayOfMonth) * lastDayOfMonth
        );
        this.summaryInfo.projectedPointSum = Math.round(
          (this.summaryInfo.totalPoints / dayOfMonth) * lastDayOfMonth
        );
        // VBA SUM(D15:J20) / Day(Date) -> 총합 / 오늘날짜(일)
        this.summaryInfo.avgMatch = this.summaryInfo.totalMatch / dayOfMonth;
      } else {
        this.summaryInfo.projectedQtySum = 0;
        this.summaryInfo.projectedPointSum = 0;
        this.summaryInfo.avgMatch = 0;
      }
    },

    // 요약 정보 초기화 메소드
    resetSummaryInfo() {
      this.summaryInfo = {
        monthlyGoalQty: null,
        dailyGoalQty: null,
        monthlyGoalPoints: null,
        dailyGoalPoints: null,
        personnelTO: null,
        personnelActual: null,
        todayMatch: null,
        totalQty: 0,
        totalPoints: 0,
        totalMatch: 0,
        projectedQtySum: null,
        projectedPointSum: null,
        avgMatch: null,
        currentDayOfMonth: new Date().getDate(),
        lastDayOfMonth: new Date(
          new Date().getFullYear(),
          new Date().getMonth() + 1,
          0
        ).getDate(),
      };
    },

    // toggleExpand() {
    //   this.isExpanded = !this.isExpanded; // 상태 토글
    // },

    // 빈 주차 객체
    createEmptyWeek(weekNum) {
      return {
        week: weekNum,
        sun: null,
        mon: null,
        tue: null,
        wed: null,
        thu: null,
        fri: null,
        sat: null, // null로 초기화
        qtySum: 0,
        pointSum: 0,
        matchSum: 0,
      };
    },

    commonValueFormatter(params) {
      const value = params.value;

      // 값이 null, undefined 또는 빈 문자열이면 빈 문자열 반환
      if (value === null || value === undefined || value === "") {
        return "";
      }

      // 그 외: 값이 숫자가 아니면(Non-numeric string) 그대로 반환
      if (isNaN(Number(value))) {
        return value;
      }
      // 숫자면 천 단위 콤마 추가하여 반환
      else {
        return Number(value).toLocaleString();
      }
    },

    commonCellStyle(params) {
      if (!params.data) return null; // 데이터 없으면 null

      const gubun = params.data.gubun;
      const value = params.value;
      const yearLabel = params.data.year.toString(); // 예: "23년" 또는 "2024년"
      const yearPart = yearLabel.substring(0, yearLabel.length - 1); // "년" 제거
      let style = {};

      if (gubun.includes("수량차이") || gubun.includes("차액")) {
        style = value < 0 ? { color: "blue" } : { color: "red" };
        if (gubun.includes("차액") && yearPart.length === 4) {
          style.backgroundColor = "#ffffff";
          // style.borderBottom = "1px solid #000000";
        }
        return style;
      }
      if (gubun.includes("사업주명"))
        // return { backgroundColor: "#ffffff", "text-align": "center" };
        return { "text-align": "center" };
      if (gubun.includes("경영지도"))
        return { backgroundColor: "#ffe8e8", "text-align": "center" };
      if (gubun.includes("부점장명"))
        return { backgroundColor: "#cbd8e1", "text-align": "center" };
      // if (gubun.includes("감사일자")) return { "text-align": "center" };
      
      if (gubun.includes("감사일자")) {
        // 연도 라벨 형식에 따라 YY 추출
        // if (yearLabel.endsWith("년")) {
          
        //   if (yearPart.length === 2) {
            // "YYYY" 형식
            return { backgroundColor: "#ffffff", "text-align": "center" };
            // return { backgroundColor: "#ffffff", "text-align": "center", "border-top": "1px solid #000000" };
        //   } 
        // }
      }
      if (gubun.includes("판매수량")) {
        // 연도 라벨 형식에 따라 YY 추출
        // if (yearLabel.endsWith("년")) {
        //   const yearPart = yearLabel.substring(0, yearLabel.length - 1); // "년" 제거
        //   if (yearPart.length === 2) {
            // "YYYY" 형식
            return { backgroundColor: "#ffffff"};
            // return { backgroundColor: "#ffffff", "text-align": "center", "border-top": "1px solid #000000" };
        //   } 
        // }
      }
      // if (
      //   gubun.includes("평균점수") 
      // ) {
      //   return { backgroundColor: "#ffffff" };
      // }

      // if (gubun.includes("예정약금")|| gubun.includes("매출액")|| gubun.includes("수수료")) return { backgroundColor: "#e7ffe5" };
      // if (gubun.includes("매출액")) return { "border-top": "1px solid #000000" };
      // if (gubun.includes("보증금액")) return { backgroundColor: "#ffffff", "border-top": "1px solid #000000", "border-bottom": "1px solid #000000" };
      if (gubun.includes("계약일") && value) {
        return { backgroundColor: "#ffff00", "text-align": "center" };
      } else if (gubun.includes("계약일") && !value) {
        return { backgroundColor: "#ffffff", "text-align": "center" };
      }

      if (gubun.includes("적용률")) return { backgroundColor: "#ffffff" };
      if (gubun.includes("평균점수") ) return { backgroundColor: "#ffffff" };
      if ( gubun == "수수료") return { backgroundColor: "#ffffff" };
      if (gubun.includes("보증금액")) return { backgroundColor: "#ffffff" };
      if (gubun.includes("이월수량")) return { backgroundColor: "#ffffff" };
      
      return null; // 기본 스타일
    },

    // --- 행 스타일 함수 (기존 getRowStyle 로직 이동) ---
    getRowStyleForGrid2(params) {
      let style = {}; // 기본 스타일 객체

      if (!params.data) {
        return null; // 데이터가 없으면 기본 스타일 반환
      }

      // 1. gubun 존재 시 텍스트 가운데 정렬 추가
      if (params.data.gubun) {
        style["text-align"] = "center"; // 가운데 정렬 스타일 추가
      }

      // 2. 연도(year) 존재 시 배경색 로직 추가
      if (params.data.year) {
        const currentYearLastTwoDigits = new Date()
          .getFullYear()
          .toString()
          .substring(2, 4); // 현재 연도 YY
        const yearLabel = params.data.year.toString(); // 예: "23년" 또는 "2024년"
        let yearLastTwoDigits = "";

        // 연도 라벨 형식에 따라 YY 추출
        if (yearLabel.endsWith("년")) {
          const yearPart = yearLabel.substring(0, yearLabel.length - 1); // "년" 제거
          if (yearPart.length === 4) {
            // "YYYY" 형식
            yearLastTwoDigits = yearPart.substring(2, 4);
          } else if (yearPart.length === 2) {
            // "YY" 형식
            yearLastTwoDigits = yearPart;
          }
        }

        if (yearLastTwoDigits) {
          const yearDiff =
            parseInt(currentYearLastTwoDigits) - parseInt(yearLastTwoDigits);

          // 연도 차이에 따른 배경색 적용
          let backgroundStyle = {};
          if (yearDiff === 5) backgroundStyle = { background: "#ead6bf" };
          else if (yearDiff === 4) backgroundStyle = { background: "#bef29e" };
          else if (yearDiff === 3) backgroundStyle = { background: "#fff0fd" };
          else if (yearDiff === 2) backgroundStyle = { background: "#dcf3fc" };
          else if (yearDiff === 1) backgroundStyle = { background: "#f1fcb8" };
          else if (yearDiff === 0) backgroundStyle = { background: "#c8fdd1" };

          // 기존 스타일 객체에 배경색 스타일 병합
          style = { ...style, ...backgroundStyle };
        }
      }

      // if (params.data.gubun && 
      // (params.data.gubun.includes("예정약금")|| params.data.gubun.includes("실제약금")|| params.data.gubun.includes("차액"))){
      //   style.background = "#FFF7DD";
      // }
      // if (params.data.gubun && 
      // (params.data.gubun.includes("매출액")|| params.data.gubun.includes("수수료")|| params.data.gubun.includes("수수료율"))){
      //   style.background = "#D9CFC7";
      // }
      // if (params.data.gubun && 
      // (params.data.gubun.includes("보증금액")|| params.data.gubun.includes("재고수량")|| params.data.gubun.includes("이월수량")||
      // params.data.gubun.includes("이월비율"))) {
      //   style.background = "#D9CFC7";
      // }

      // 최종 스타일 객체 반환 (스타일이 적용된 경우) 또는 null 반환 (적용된 스타일이 없는 경우)
      return Object.keys(style).length > 0 ? style : null;
    },
  },

  computed: {
    weeklySalesData() {
      if (!this.mainTableData || this.mainTableData.length === 0) {
        return { qtyWeeks: [], pointWeeks: [], matchWeeks: [] }; // matchWeeks 추가
      }

      const sortedData = [...this.mainTableData].sort((a, b) =>
        a.YYYYMMDD.localeCompare(b.YYYYMMDD),
      );

      const qtyWeeks = [];
      const pointWeeks = [];
      const matchWeeks = []; // 적합도 주차 배열 추가
      let currentWeekNum = 1;
      let currentQtyWeek = this.createEmptyWeek(currentWeekNum);
      let currentPointWeek = this.createEmptyWeek(currentWeekNum);
      let currentMatchWeek = this.createEmptyWeek(currentWeekNum); // 적합도 객체 초기화
      let weekHasData = false;

      const dayMap = ["sun", "mon", "tue", "wed", "thu", "fri", "sat"];

      // 해당 월의 첫 날 요일 계산 (0: 일요일, 6: 토요일)
      const firstDayOfMonth = new Date(
        parseInt(sortedData[0].YYYYMMDD.substring(0, 4)),
        parseInt(sortedData[0].YYYYMMDD.substring(4, 6)) - 1,
        1,
      ).getDay();

      sortedData.forEach((dayData) => {
        const dayOfMonth = parseInt(dayData.YYYYMMDD.substring(6, 8));
        const dayOfWeekIndex = parseInt(dayData.D) - 1; // 0: 일요일, 6: 토요일
        const dayKey = dayMap[dayOfWeekIndex];
        // const dateString = dayData.YYYYMMDD; // 현재 데이터의 날짜 (YYYYMMDD)

        const weekOfMonth =
          Math.floor((dayOfMonth - 1 + firstDayOfMonth) / 7) + 1;

        // 계산된 주차(weekOfMonth)가 현재 주차(currentWeekNum)와 다르면 새 주 시작
        if (weekOfMonth > currentWeekNum && weekHasData) {
          // 이전 주 합계 포맷팅
          currentPointWeek.pointSum = Math.round(
            currentPointWeek.pointSum,
          ).toLocaleString();
          // 이전 주 데이터 저장
          qtyWeeks.push(currentQtyWeek);
          pointWeeks.push(currentPointWeek);
          matchWeeks.push(currentMatchWeek); // 적합도 주 저장

          currentWeekNum = weekOfMonth; // 다음 주로 업데이트
          currentQtyWeek = this.createEmptyWeek(currentWeekNum);
          currentPointWeek = this.createEmptyWeek(currentWeekNum);
          currentMatchWeek = this.createEmptyWeek(currentWeekNum); // 새 적합도 객체
          weekHasData = false;
        }
        // 첫 데이터 처리 시 currentWeekNum 설정
        if (!weekHasData) {
          currentWeekNum = weekOfMonth;
          currentQtyWeek.week = currentWeekNum;
          currentPointWeek.week = currentWeekNum;
          currentMatchWeek.week = currentWeekNum;
        }

        // 데이터 할당
        const saleQty = parseInt(dayData.SALE_QTY || 0);
        const sumPointDay = parseFloat(dayData.SUM_POINT_DAY || 0);
        const matchValue = parseInt(dayData.MATCH || 0);

        currentQtyWeek[dayKey] = saleQty;
        currentPointWeek[dayKey] = Math.round(sumPointDay).toLocaleString();
        currentMatchWeek[dayKey] = matchValue; // 적합도 값 할당

        // 주간 합계 누적
        currentQtyWeek.qtySum += saleQty;
        currentPointWeek.pointSum += sumPointDay; // 합계는 반올림/포맷팅 전 값으로 누적
        currentMatchWeek.matchSum += matchValue; // 오늘까지의 값만 합산

        weekHasData = true;
      });

      // 마지막 주 데이터 추가
      if (weekHasData) {
        qtyWeeks.push(currentQtyWeek);
        pointWeeks.push(currentPointWeek);
        matchWeeks.push(currentMatchWeek);
      }

      // 6주까지 강제로 채우기
      while (qtyWeeks.length < 6) {
        const weekNum = qtyWeeks.length + 1;
        qtyWeeks.push(this.createEmptyWeek(weekNum));
        pointWeeks.push(this.createEmptyWeek(weekNum));
        matchWeeks.push(this.createEmptyWeek(weekNum));
      }

      return { qtyWeeks, pointWeeks, matchWeeks }; // matchWeeks 포함하여 반환
    },
  },
};
</script>

<style scoped>

/* 전체 레이아웃 */
.tr-popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  font-family: "Malgun Gothic", Arial, sans-serif;
}
.tr-popup-body {
  overflow-y: auto;
  /* padding: 1px; */
}

/* 왼쪽 섹션 */
.tr-Popup-section {
  width: 70%;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.5);
  display: flex;
  flex-direction: column;
  max-height: 90vh;
}

/* 메인 테이블 컨테이너 - 기본 (접힌) 상태 */
.main-table-container {
  overflow-y: visible; /* 내용 보이도록 */
}

/* 분석 테이블 스타일 */
.analysis-table {
  table-layout: fixed; /* 셀 크기를 균일하게 유지 */
  width: 100%;
  border-collapse: collapse;
  font-size: 0.8rem;
}

.analysis-table th,
.analysis-table td {
  border: 1px solid black;
  text-align: center;
  padding: 5px;
}

/* .analysis-table th {
  background-color: #f0f0f0;
} */

.analysis-table td {
  background-color: #ffffff;
  text-align: right;
  font-weight: bold;
}

/* 요약 정보 테이블 스타일 추가 */
.summary-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.8rem;
  margin-bottom: 10px; /* 메인 테이블과의 간격 */
  background-color: #f8f8f8; /* 약간 다른 배경색 */
}

.summary-table th,
.summary-table td {
  border: 1px solid #ccc;
  text-align: center;
  padding: 4px;
}

.summary-table th {
  background-color: #e0e0e0;
  font-weight: bold;
  width: 10%; /* 헤더 너비 고정 시도 */
}
.summary-table td {
  width: 10%; /* 데이터 셀 너비 고정 시도 */
}

/* 메인 테이블 스타일 */
.main-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.8rem;
}

.main-table thead tr th:nth-child(2) {
  /* thead 안의 tr의 두 번째 th ("항목") */
  width: 10%; /* 원하는 너비 값으로 조절하세요 (예: 80px) */
}

.main-table tbody tr td:nth-child(2)[rowspan] {
  writing-mode: vertical-rl;
  text-orientation: upright;
  vertical-align: middle;
  text-align: center;
}

.main-table .score-row td {
  background-color: #f7f7ce;
  text-align: center;
  padding: 4px;
  font-weight: bold;
}

.main-table .score-row td:nth-last-child(-n + 7) {
  color: #0000ff; /* 원하는 새로운 배경색으로 변경 (예: 연한 녹색) */
  /* 다른 스타일은 기본 .score-row td 스타일을 상속 */
}

.main-table tbody > tr.score-row:last-of-type td[colspan="2"]:nth-of-type(1),
.main-table tbody > tr.score-row:last-of-type td[colspan="2"]:nth-of-type(3) {
  color: black; /* .score-row 기본 배경색 */
}

/* --- 인원적합도 행 스타일 --- */
.main-table .match-row td {
  background-color: #e9cec9;
  text-align: center;
  padding: 4px;
  font-weight: bold;
}

.main-table .match-row td:nth-last-child(-n + 7) {
  color: #ff0000; /* 원하는 새로운 배경색으로 변경 */
  /* 다른 스타일은 기본 .score-row td 스타일을 상속 */
}

/* 인원적합도 요약 행: 평균 라벨 셀 배경색 (기본 match-row 색상으로 복원) */
.main-table tbody > tr.match-row:last-of-type td[colspan="2"]:nth-of-type(1) {
  color: black; /* .match-row 기본 배경색 */
}

.main-table th,
.main-table td {
  border: 1px solid black;
  text-align: center;
  padding: 4px;
}

.main-table th {
  background-color: #a0caf3;
  font-weight: bold;
}

.main-table td {
  background-color: #ffffff;
  font-weight: bold;
  height: 5px;
}

:deep(.ag-trPop-balham) {
  --ag-cell-horizontal-padding: 2px; /* 셀 내부 좌우 패딩 */
  --ag-cell-vertical-padding: 1px; /* 셀 내부 상하 패딩 */
}

/* grid 헤더 스타일 */
:deep(.ag-trPop-balham .ag-header-cell-text) {
  color: #333; /* 텍스트 색상 */
  font-size: 0.725rem;
}
/* grid 헤더 스타일 */
:deep(.ag-trPop-balham .ag-header-cell) {
  background-color: #f7f7f7; /* 밝은 배경색 */
}

/* grid 헤더 텍스트 정렬 */
:deep(.ag-trPop-balham .ag-header-cell-label) {
  justify-content: center !important;
  white-space: pre-line;
}

/* grid 데이터 셀 스타일 */
:deep(.ag-trPop-balham .ag-cell) {
  font-size: 0.8rem;
  text-align: right;
}
/* grid 헤더 배경색 */
:deep(.ag-trPop-balham .ag-header-container) {
  /* 헤더 배경색 */
  background-color: #f0f0f0 !important;
}

:deep(.right-grid .ag-row-hover) {
  background-color: #80ff80; /* 적절히 어두운 배경색 */
  border: 1px solid #ffffff; /* 밝은 테두리 */
}

:deep(.ag-trPop-balham .ag-cell.ag-column-first.year-cell) {
  font-weight: bold;
  font-size: 0.9rem;
  writing-mode: vertical-rl; /* 세로 쓰기 모드 */
  text-orientation: upright; /* 세로 텍스트 방향 */
  padding-right: 5px;
  width: 20px;
}


/* 1024px 초과일 때 폰트/행 높이 증가 */
@media (min-width: 1025px) {
  :deep(.ag-trPop-balham .ag-cell) {
    font-size: 1rem;
  }
  :deep(.ag-trPop-balham .ag-header-cell-text) {
    font-size: 0.85rem;
  }
}

.toggle-button-container {
  padding-top: 1px; /* 테이블과의 간격 */
  box-sizing: border-box; /* 패딩 포함하여 너비 계산 */
}

.toggle-button {
  font-size: 1rem;
  cursor: pointer;
  color: white;
  border: none;
  border-radius: 5px;
  width: 100%; /* 버튼 너비를 100%로 설정 */
  box-sizing: border-box;
  padding: 1px; /* 버튼 내부 여백 */
}

.toggle-button:hover {
  background-color: #0056b3;
}

.popup-title {
  font-weight: 700;
}

.tr-popup-header {
  display: flex;
  justify-content: space-between;
  padding: 8px 12px;
  background: #f2f2f2;
  border-bottom: 1px solid #ddd;
  flex: 0 0 auto;
}

</style>
